import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {IOrder, IOrderAPI, IOrderPledger, IOrderType, IPledgersTransfer} from './order.interface';
import {tap} from "rxjs/operators";
import {IUser} from "../user/user.interface";

@Injectable()
export class OrderService {
  constructor(private http: HttpClient) {
  }

  list(page: number = 1, q: string = '', type: IOrder['type'] = IOrderType.new, limit = 300, orderBy = 'id'): Observable<IOrderAPI> {
    const params = {page, q, type, limit, 'order-by': orderBy};
    return this.http.get<IOrderAPI>(`${environment.apiEndpoint}/orderdesc`, {params});
  }

  one(id: IOrder['id']): Observable<IOrder> {
    return this.http.get<IOrder>(`${environment.apiEndpoint}/orderdesc/${id}`);
  }

  userVotes(id: IOrder['id']): Observable<IUser[]> {
    return this.http.get<IUser[]>(`${environment.apiEndpoint}/orderdesc/${id}/votes`);
  }

  pledgers(id: IOrder['id']): Observable<IOrderPledger[]> {
    return this.http.get<IOrderPledger[]>(`${environment.apiEndpoint}/orderdesc/${id}/pledges`);
  }

  pledgersToSkladchina(id: IOrder['id'], course_id: number): Observable<IPledgersTransfer> {
    return this.http.post<IPledgersTransfer>(`${environment.apiEndpoint}/orderdesc/${id}/pledges/to-skladchina`, {course_id});
  }

  update(id: IOrder['id'], body: Partial<IOrder>): Observable<IOrder> {
    return this.http.patch<IOrder>(`${environment.apiEndpoint}/orderdesc/${id}`, body);
  }

  create(body: Partial<IOrder>): Observable<IOrder> {
    return this.http.post<IOrder>(`${environment.apiEndpoint}/orderdesc`, body);
  }

  delete(id: IOrder['id']): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/orderdesc/${id}`);
  }

  sync(id: IOrder['id']): Observable<IOrder> {
    return this.http.get<IOrder>(`${environment.apiEndpoint}/orderdesc/reparse/${id}`).pipe(
      tap((res: any) => Object.assign({
          id: Number(res.id),
          user_id: Number(res.user_id)
        }, res)
      )
    );
  }
}
